import { InputNumber, Space } from 'antd'

import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { InputNumberRangeProps } from './interface'

const Component = ({
  className,
  style,
  split = '-',
  value: values = [undefined, undefined],
  onChange,
  ...restProps
}: InputNumberRangeProps) => {
  const handleFirstChange = (value: number | string | null) => {
    onChange?.([value ?? undefined, values[1]])
  }

  const handleSecondChange = (value: number | string | null) => {
    onChange?.([values[0], value ?? undefined])
  }

  return (
    <Space
      className={className}
      orientation='horizontal'
      separator={split}
      size='small'
      style={style}
      wrap={false}
    >
      <InputNumber
        value={values[0]}
        onChange={handleFirstChange}
        {...restProps}
      />
      <InputNumber
        value={values[1]}
        onChange={handleSecondChange}
        {...restProps}
      />
    </Space>
  )
}

export const InputNumberRange = connect(
  Component,
  mapReadPretty(Component, { disabled: true })
) as typeof Component
